import { Auth0ProviderOptions } from '@auth0/auth0-react'
import { navigate } from 'gatsby'
import { defaultIfEmpty, filter, map, skipWhile, switchMap, take } from 'rxjs'

import { userClaimIds } from '../../utils/userClaims'
import { latestAuthState$ } from '../auth/state'
import { addDispensaryBasePathToPath } from '../dispensaries'
import { dispensaryExternalEffect$ } from '../dispensaries/effects'
import { saveBeforeOnboardingState } from '../onboarding/utils'

export const onRedirectCallback: Auth0ProviderOptions['onRedirectCallback'] = (appState) => {
  latestAuthState$
    .pipe(
      skipWhile((authState) => authState.isLoading),
      take(1),
      switchMap((authState) => {
        const isFirstLogin = authState.user?.[userClaimIds.loginsCount] <= 1
        const isOnboarding = [
          userClaimIds.onboardPatient,
          userClaimIds.onboardPractitioner,
          userClaimIds.onboardStudent,
        ].some((claimId) => authState.user?.[claimId])

        const redirectToOnboarding = isFirstLogin && isOnboarding
        const returnTo = redirectToOnboarding ? '/onboarding' : appState?.returnTo || '/'

        if (redirectToOnboarding && appState && !appState?.returnTo?.includes('onboarding')) {
          saveBeforeOnboardingState(appState)
        }

        // proactively check for a dispensary redirect to avoid a double redirect (i.e. if
        // the user will be redirected to a dispensary, take them there directly)

        return dispensaryExternalEffect$.pipe(
          // Only filter to redirect effects when NOT going to onboarding
          // Keep all effect types (including notify) when going to onboarding
          filter((effect) => returnTo === '/onboarding' || effect._tag === 'redirect'),
          map((effect) => {
            // take the user directly to their dispensary
            const dispensaryReturnTo = addDispensaryBasePathToPath(effect.dispensary.slug, returnTo)
            return () => navigate(dispensaryReturnTo, { replace: true })
          }),
          // if there is no dispensary redirect, take the user to the original `returnTo`
          defaultIfEmpty(() =>
            // Use Gatsby's navigate method to replace the url
            navigate(returnTo, { replace: true }),
          ),
        )
      }),
    )
    .subscribe((effect) => effect())
}
